import React from "react";
import { usePopup } from '../../context/PopupContext';

interface OpenButtonProps {
    text: React.ReactNode;
    newContent: React.ReactNode;
    styleClasses?: string;
}

export default function OpenButton({ text, newContent, styleClasses }: OpenButtonProps) {
    const { setPopupContent, openPopup } = usePopup();

    const handleClick = () => {
        setPopupContent(newContent);
        openPopup();
    };

    return (
        <button onClick={handleClick} className={styleClasses + ` rounded transition`}>
            {text}
        </button>
    );
}